import { useEffect } from "react";

export default function BuyMeACoffee() {
	useEffect(() => {
		const script = document.createElement("script");
		script.setAttribute("data-name", "BMC-Widget");
		script.src = "https://cdnjs.buymeacoffee.com/1.0.0/widget.prod.min.js";
		script.setAttribute("data-id", "focus.rpg");
		script.setAttribute("data-description", "Support me on Buy me a coffee!");
		script.setAttribute(
			"data-message",
			"Podoba Ci się Focus? Wesprzyj rozwój systemu i pomóż tworzyć jeszcze lepsze sesje. Dzięki! 🎲🧙",
		);
		script.setAttribute("data-color", "#FFDD00");
		script.setAttribute("data-position", "Right");
		script.setAttribute("data-x_margin", "18");
		script.setAttribute("data-y_margin", "18");
		script.async = true;
		document.head.appendChild(script);
		script.onload = function () {
			var evt = document.createEvent("Event");
			evt.initEvent("DOMContentLoaded", false, false);
			window.dispatchEvent(evt);
		};

        const div = document.getElementById("supportByBMC");
		if (div) {
			div.appendChild(script);
		}
	}, []);

	return <div id="supportByBMC"></div>;
}